const CONFIG_KEY = 'dosdetres_config';
const DEFAULT_WEBHOOK = 'https://script.google.com/macros/s/AKfycbzKZ79YVb0fJMLmfaSNG_WpYFg4SGLiWIlZnK5849cSlwNUx4oM-o0gefv9fAR6uHzu9Q/exec';

interface AppConfig {
  sheetsWebhookUrl: string;
}

export function getConfig(): AppConfig {
  try {
    const raw = localStorage.getItem(CONFIG_KEY);
    const stored = raw ? JSON.parse(raw) : {};
    return { sheetsWebhookUrl: stored.sheetsWebhookUrl || DEFAULT_WEBHOOK };
  } catch {
    return { sheetsWebhookUrl: DEFAULT_WEBHOOK };
  }
}

export function saveConfig(config: AppConfig): void {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
}

export async function sendToGoogleSheets(order: Record<string, unknown>): Promise<boolean> {
  const { sheetsWebhookUrl } = getConfig();
  if (!sheetsWebhookUrl) return false;
  try {
    await fetch(sheetsWebhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(order),
    });
    return true;
  } catch {
    return false;
  }
}
